import { useTranslation } from "react-i18next";
import { useAppTheme } from "../../useAppTheme";
import { useDevice } from "../../useDevice";
import { AnimatedHeaderScreen } from "../AnimatedHeaderScreen";
import Box from "../Box";
import CustomTabs from "../CustomTabs";
import { LessonDetailBottomBar } from "./LessonDetailBottomBar";
import { LessonDetailProgress } from "./LessonDetailProgress";
import { LessonDetailTitleSection } from "./LessonDetailTitleSection";

type Props = {
	title: string;
	description: string;
	progressPercent: number;
	tabs: React.ComponentProps<typeof CustomTabs>["tabs"];
	onTabChangeIndex?: (index: number) => void;
	coverImage?: string;
	bottomCtaLabel?: string;
	onBackPress: () => void;
	onTakeQuizPress: () => void;
};

export const LessonDetailViewScreen = ({
	title,
	description,
	progressPercent,
	tabs,
	onTabChangeIndex,
	coverImage,
	bottomCtaLabel,
	onBackPress,
	onTakeQuizPress,
}: Props) => {
	const theme = useAppTheme();
	const { isMobile } = useDevice();
	const { t } = useTranslation();

	return (
		<AnimatedHeaderScreen
			title={title}
			coverImage={coverImage}
			leadingAction={{
				icon: "arrow-left",
				accessibilityLabel: t("common.goBack"),
				onPress: onBackPress,
			}}
			renderHero={({ invertColors, onTitleLayout, titleVariant }) => (
				<>
					<LessonDetailTitleSection
						title={title}
						description={description}
						invertColors={invertColors}
						titleVariant={titleVariant}
						onTitleLayout={onTitleLayout}
					/>
					<Box marginTop={16} paddingHorizontal={16}>
						<LessonDetailProgress
							percent={progressPercent}
							invertColors={invertColors}
						/>
					</Box>
				</>
			)}
			bottomBar={
				<LessonDetailBottomBar
					label={bottomCtaLabel}
					onPress={onTakeQuizPress}
				/>
			}
		>
			<CustomTabs
				tabs={tabs}
				mode="fixed"
				onChangeIndex={onTabChangeIndex}
				backgroundColor={
					isMobile ? theme.colors.elevation.level1 : "transparent"
				}
			/>
		</AnimatedHeaderScreen>
	);
};
